const dWebUrls = [
    "/subscription-plan/myplan",
    "/partner-offers",
    "/offer-detail/:partner_id/:partnership_benefit_id",
    "/cart",
    "/cart/address-page",
    "/cart/prescription",
    "/cart/summary-page",
    "/cart/select-shipment",
    "/cart/payment",
    "/cart/payment/recharge",
    "/cart/checkout/success",
    "/order-payment/",
    "/done-in-one/prescription-order",
    "/done-in-one/rx-order-preview",
    "/done-in-one/rx-order-processing",
    "/done-in-one/cart/address-page",
    "/corporate/labs/patient",
    "/corporate/labs/packages",
    "/corporate/labs/progress/:test_id",
    "/corporate/labs/review",
    "/corporate/labs/summary",
    "/labs/cart",
    "/labs/cart/summary-page",
    "/labs/cart/address-page",
    "/labs/cart/patient-page",
    "/labs/cart/payment",
]

export const checkUrlExistenceInList = (url, urlArray) => {
    if (!url) return false
    const trimmedUrl = url.trim()
    const withoutParams = trimmedUrl.split("?")[0]
    const parts = withoutParams.split("/")
    if (url[0] === "/") parts.shift()
    for (const pwaUrl of urlArray) {
        if (trimmedUrl === pwaUrl) return true
        const expectedParts = pwaUrl.split("/")
        expectedParts.shift()
        let index = 0
        let isPwa = true
        for (const expectedPart of expectedParts) {
            if (expectedPart[0] === ":") {
                index++
                continue
            }
            if (expectedPart != parts[index]) {
                isPwa = false
                break
            }
            index++
        }
        if (isPwa && index == parts.length) return true
    }
    return false
}

export const isPwaUrl = (url) => {
    return url && checkUrlExistenceInList(url, dWebUrls)
}

export const isDwebUrl = (url) => {
    return url && checkUrlExistenceInList(url, dWebUrls)
}

export const isLabsPwaUrl = (url) => {
    if (url.match(/^\/labs/)) {
        return true
    }
    return false
}

export const isPostCartLabsDLSUrl = (url) => {
    if (url.includes("/labs/cart")) {
        return true
    }
    return false
}
